import React, { useState } from 'react';
import './wavesStyle.css';
import WaveIcon from './WaveIcon';
import { TextField, Snackbar } from '@mui/material';
import { sendEmail } from '../../services/whatsApp';

const WavesForm = () => {
  const isMobile = window.innerWidth < 768;

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [successMessageOpen, setSuccessMessageOpen] = useState(false);
  const [errorMessageOpen, setErrorMessageOpen] = useState(false);
  const [missingDataMessageOpen, setMissingDataMessageOpen] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent the default form submission behavior

    // Check if any required field is missing
    if (!name || !email || !message) {
      setMissingDataMessageOpen(true);
      return;
    }

    try {
      // Prepare the email body
      const body = {
        to: 'admin@jahninstitute.com', // Your email address
        subject: 'Contacto',
        text: `Name: ${name}\nCompany: ${email}\nMessage: ${message}`,
      };

      // Call the sendEmail function with the email body
      await sendEmail(body);

      // Show success message
      setSuccessMessageOpen(true);

      // Clear the form fields after successful submission
      setName('');
      setEmail('');
      setMessage('');
    } catch (error) {
      console.error('Error sending email:', error);
      // Show error message
      setErrorMessageOpen(true);
    }
  };

  const handleCloseSuccessMessage = () => {
    setSuccessMessageOpen(false);
  };

  const handleCloseErrorMessage = () => {
    setErrorMessageOpen(false);
  };

  const handleCloseMissingDataMessage = () => {
    setMissingDataMessageOpen(false);
  };

  return (
    <>
      <div className="header">
        <div className="flex flex-wrap justify-around items-center w-full">
          <div className="text-continer flex flex-col gap-10 w-full md:w-3/4 p-5">
            <h2>Logra que tu organización se sienta en buenas manos</h2>
            <h6 className="text-center">
              En <b>Jahn Institute</b> estamos listos para ayudarte a visibilizar tu autoridad. Es momento de{' '}
              <b>
                transformar a las personas en líderes comprometidos, resilientes 
                y con sentimientos de arraigo y pertenencia para fortalecer a tu empresa.
              </b>
            </h6>
          </div>
          <div className="form-container px-2 md:px-10 flex flex-col gap-5">
            <form onSubmit={handleSubmit}>
              <div className="flex flex-wrap justify-center items-center gap-3 w-full">
                <TextField
                  id="name"
                  label="Nombre"
                  variant="outlined"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  sx={{ m: 1, width: isMobile ? '100%' : '40ch' }}
                />
                <TextField
                  id="email"
                  label="Correo"
                  variant="outlined"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={{ m: 1, width: isMobile ? '100%' : '40ch' }}
                />
              </div>
              <TextField
                id="message"
                label="Mensaje"
                multiline
                rows={5}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                sx={{ m: 1, width: isMobile ? '100%' : '82ch' }}
                defaultValue="Mensaje"
              />
              <div className="w-full py-5">
                <button type="submit" className="button-23">
                  Contactar
                </button>
              </div>
            </form>
          </div>
        </div>
        <div>
          <WaveIcon />
        </div>
      </div>
      {/* Success message */}
      <Snackbar
        open={successMessageOpen}
        autoHideDuration={6000}
        onClose={handleCloseSuccessMessage}
        message="Email enviado correctamente"
      />
      {/* Error message */}
      <Snackbar
        open={errorMessageOpen}
        autoHideDuration={6000}
        onClose={handleCloseErrorMessage}
        message="Error al enviar el email. Inténtalo de nuevo."
      />
      {/* Missing data message */}
      <Snackbar
        open={missingDataMessageOpen}
        autoHideDuration={6000}
        onClose={handleCloseMissingDataMessage}
        message="Por favor, complete todos los campos."
      />
    </>
  );
};

export default WavesForm;
